<template>
  <g id="Group_7093" data-name="Group 7093" transform="translate(-15 -12)">
    <rect id="Rectangle_4" data-name="Rectangle 4" width="29" height="2" rx="1" transform="translate(15 12)" />
    <rect id="Rectangle_5" data-name="Rectangle 5" width="29" height="2" rx="1" transform="translate(15 24)" />
    <rect id="Rectangle_6" data-name="Rectangle 6" width="29" height="2" rx="1" transform="translate(15 36)" />
  </g>
</template>
